'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeedDialItem = exports.SpeedDial = undefined;

var _speedDial = require('./speed-dial');

var _speedDialItem = require('./speed-dial-item');

exports.SpeedDial = _speedDial.SpeedDial;
exports.SpeedDialItem = _speedDialItem.SpeedDialItem;


//////////////////
// WEBPACK FOOTER
// ./~/react-mui-speeddial/dist/index.js
// module id = 999
// module chunks = 0